import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { RatingAxes } from '../constants/RatingAxes';
import Rating from './Rating';
import ReviewBody from './ReviewBody';
import ReviewReplyThread from './ReviewReplyThread';
import ReviewerInfo from './ReviewerInfo';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultReviewRenderer({
  review,
  catalogServices,
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "default-rendered-review",
    marginBlockStart: "800",
    as: "div",
    children: [/*#__PURE__*/_jsx(Rating, {
      rating: review.get('ratings').get(RatingAxes.OVERALL),
      label: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: review.get('createdAt'),
        format: "ll",
        type: "userTz"
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      onTrackInteraction: onTrackInteraction,
      className: "m-top-4",
      catalogServices: catalogServices,
      review: review
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      inline: true,
      review: review
    }), /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.get('reply')
    })]
  });
}